<template>
  <el-dialog :visible.sync="visible" class="editDialog" :title="title" :close-on-click-modal="false" @close="close" @open="getOpen">
    <el-form :model="detail" class="addDetail" :rules="(status != 'readonly') ? rules : {}" ref="detail" label-width="110px">
      <el-form-item label="消防系统" prop="fireControlSystem">
        <el-select :popper-append-to-body="false" v-model="detail.fireControlSystem" placeholder="请选择消防系统" clearable>
          <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备类型" prop="deviceType">
        <el-input placeholder="请输入设备类型" v-model="detail.deviceType" maxlength="200">
        </el-input>
      </el-form-item>
      <el-form-item label="检查标准" prop="inspectionStandard">
        <el-input placeholder="请输入检查标准" v-model="detail.inspectionStandard" maxlength="200">
        </el-input>
      </el-form-item>
      <el-form-item label="检查方法" prop="inspectionMethod">
        <el-input placeholder="请输入检查方法" v-model="detail.inspectionMethod" maxlength="200">
        </el-input>
      </el-form-item>
      <el-form-item label="检查结果" prop="inspectionResult">
        <el-input placeholder="请输入检查结果,多个逗号分隔" v-model="detail.inspectionResult" maxlength="200">
        </el-input>
      </el-form-item>
      <div class="tips" style="margin: 10px 0;width: 420px;color:#fff;font-size: 13px;"><span
          style="color: #F56C6C;margin-right: 4px;display: inline-block;">*</span>Tips:检查结果规则对应检查结果示例：0表示正常，不转成维修单，1表示异常，转成维修单，-1表示默认最后一项。
      </div>
      <el-form-item label="检查结果规则" prop="inspectionResultRule">
        <el-input placeholder="默认-1，多个逗号分隔" v-model="detail.inspectionResultRule" maxlength="100">
        </el-input>
      </el-form-item>
      <el-form-item label="指导视频内容" prop="guidanceVideo">
        <el-select :popper-append-to-body="false" v-model="detail.guidanceVideo" placeholder="请选择指导视频" clearable>
          <el-option v-for="item in videoList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生命周期管理" prop="isFrequency">
        <el-select :popper-append-to-body="false" v-model="detail.isFrequency" placeholder="请选择">
          <el-option v-for="item in remindList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <p style="margin-top: 30px; display: flex; justify-content: flex-end">
      <button class='w_next_button cancelButton' @click.prevent="cancel">取消</button>
      <button class='w_next_button confirmButton' style="margin-left: 20px" @click.prevent="confirmSubmit">确认</button>
    </p>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'adding'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        fireControlSystem: [
          { required: true, message: '请选择消防系统', trigger: 'change' }
        ],
        deviceType: [
          { required: true, message: '请输入设备类型', trigger: 'blur' }
        ],
        inspectionStandard: [
          { required: true, message: '请输入检查标准', trigger: 'blur' }
        ],
        inspectionMethod: [
          { required: true, message: '请输入检查方法', trigger: 'blur' }
        ],
        inspectionResult: [
          { required: true, message: '请输入检查结果', trigger: 'blur' }
        ]
      },
      detail: {},
      visible: this.value,
      videoList: [],
      systemList: [],
      remindList: [
        {
          label: '是',
          value: 0
        },
        {
          label: '否',
          value: 1
        }
      ]
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val)
    },
    visible(value) {
      this.$emit('input', value)
    }
  },
  computed: {
    title() {
      if (this.status == 'adding') {
        return '新增'
      } else if (this.status == 'editing') {
        return '编辑'
      } else if (this.status == 'readonly') {
        return '详情'
      }
    }
  },
  methods: {
    setCurrentValue(val) {
      let data = this.data
      if (val) {
        this.getVideoList()
        this.getSystemList()
      }
      if (this.status == 'editing') {
        this.detail = data
      } else if (this.status == 'adding') {
        this.detail = {}
        this.$set(this.detail, 'inspectionResultRule', '-1')
        this.$set(this.detail, 'isFrequency', 1)
      }
      this.visible = val
    },
    getVideoList() {
      this.$axiosget('manager/company/contents', {
        params: {
          companyId: localStorage.getItem('companyId'),
          contentType: 1
        }
      }).then((res) => {
        this.videoList = res.data.data
      })
    },
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'pointInspectFireCS'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    getOpen() {
      this.$nextTick(() => {
        this.$refs.detail.clearValidate()
      })
    },
    close() {
      this.detail = {}
      this.$nextTick(() => {
        this.$refs.detail.resetFields()
      })
    },
    cancel() {
      this.close()
      this.visible = false
    },
    confirmSubmit() {
      this.$refs.detail.validate((valid) => {
        if (valid) {
          if (this.status == 'adding') {
            this.$axiospost('extra/pointInspectContentItem', {
              ...this.detail,
              inspectionResultRule: this.detail.inspectionResultRule
                ? this.detail.inspectionResultRule
                : '-1'
            }).then((res) => {
              if (res.data.status == '10000') {
                this.$message.success('提交成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          } else {
            this.$axiosput('extra/pointInspectContentItem', {
              ...this.detail,
              inspectionResultRule: this.detail.inspectionResultRule
                ? this.detail.inspectionResultRule
                : '-1'
            }).then((res) => {
              if (res.data.status == '10000') {
                this.$message.success('修改成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/inspectContent/addEditDialog.vue